import { render, staticRenderFns } from "./SubOrganizationsList.vue?vue&type=template&id=7e2ad15d&scoped=true&"
import script from "./SubOrganizationsList.vue?vue&type=script&lang=js&"
export * from "./SubOrganizationsList.vue?vue&type=script&lang=js&"
import style0 from "./SubOrganizationsList.vue?vue&type=style&index=0&id=7e2ad15d&scoped=true&lang=scss&"
import style1 from "./SubOrganizationsList.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7e2ad15d",
  null
  
)

export default component.exports